import React,{Fragment}from'react';/**
 * @return {null}
 */var Loading=function Loading(){return React.createElement(Fragment,null,null);};export default Loading;